import WebApp from '@twa-dev/sdk';

import { isTMA } from './is-tma';

export const setCloudStorageValue = (key: string, value: string) => {
  return new Promise<void>((resolve) => {
    if (!isTMA()) {
      return resolve(localStorage.setItem(key, value));
    }

    try {
      WebApp.CloudStorage.setItem(key, value, (error) => {
        if (error) {
          resolve(localStorage.setItem(key, value));
        }
        resolve();
      });
    } catch {
      resolve(localStorage.setItem(key, value));
    }
  });
};

export const getCloudStorageValue = (key: string) => {
  const value: string | null = null;

  return new Promise<string | null>((resolve) => {
    if (!isTMA()) {
      return resolve(localStorage.getItem(key));
    }

    try {
      WebApp.CloudStorage.getItem(key, (error: any, storedValue: any) => {
        const storedValueFromLocalStorage = localStorage.getItem(key);

        if (error) {
          resolve(storedValueFromLocalStorage);
        } else {
          if (storedValue === '') resolve(null);
          resolve(storedValue);
        }
      });
    } catch {
      resolve(localStorage.getItem(key));
    }

    return resolve(value);
  });
};

export const removeCloudStorageValue = (key: string) => {
  return new Promise<void>((resolve) => {
    if (!isTMA()) {
      return resolve(localStorage.removeItem(key));
    }

    try {
      WebApp.CloudStorage.removeItem(key, (error) => {
        if (error) {
          resolve(localStorage.removeItem(key));
        }
        resolve();
      });
    } catch {
      resolve(localStorage.removeItem(key));
    }
  });
};

export const getCloudStorageKeys = (): Promise<string[]> => {
  const getAllKeys = () => {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) keys.push(key);
    }
    return keys;
  };

  return new Promise<string[]>((resolve) => {
    if (!isTMA()) {
      return resolve(getAllKeys());
    }

    try {
      WebApp.CloudStorage.getKeys((error, storedKeys) => {
        if (error) {
          resolve(getAllKeys());
        } else {
          resolve(storedKeys || []);
        }
      });
    } catch {
      resolve(getAllKeys());
    }
  });
};

export const getCloudStorageValues = () => {
  const value: string | null = null;

  return new Promise<Record<string, string | null>>((resolve) => {
    if (!isTMA()) {
      return resolve({ ...localStorage });
    }

    try {
      getCloudStorageKeys().then((keys) => {
        WebApp.CloudStorage.getItems(keys, (err, values) => {
          if (err) return resolve({ ...localStorage });

          return resolve(values ?? {});
        });
      });
    } catch {
      resolve({ ...localStorage });
    }

    return value;
  });
};

export const removeCloudStorageValues = (keys: string[]): Promise<void> => {
  const removeAllKeys = () => {
    for (const key of keys) {
      localStorage.removeItem(key);
    }
  };

  return new Promise<void>((resolve) => {
    if (!isTMA()) {
      removeAllKeys();
      return resolve();
    }

    try {
      WebApp.CloudStorage.removeItems(keys, (error) => {
        if (error) {
          removeAllKeys();
        }
        resolve();
      });
    } catch {
      removeAllKeys();
      resolve();
    }
  });
};
